@if (visible()) {
  <section class="ui-toast" [attr.data-type]="type()" role="status" aria-live="polite">
    <svg class="ui-toast__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path [attr.d]="iconPath()"></path>
    </svg>

    <div class="ui-toast__content">
      <strong>{{ title() }}</strong>
      <p>{{ message() }}</p>
    </div>

    <button class="ui-toast__close" type="button" (click)="dismiss.emit()" aria-label="Close">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m18.3 5.7-1-1L12 10 6.7 4.7l-1 1L11 11l-5.3 5.3 1 1L12 12l5.3 5.3 1-1L13 11z" />
      </svg>
    </button>
  </section>
}
